import React from 'react';
import { element } from 'prop-types';
import { brandShape } from 'shapes';
import { BrandLocker } from './components';
import BrandProvider from './components/BrandProvider';

const BrandPage = ({ value, children }) => {
    return (
        <BrandProvider brand={value}>
            <BrandLocker brand={value} />
            {children}
        </BrandProvider>
    );
};

BrandPage.propTypes = {
    value: brandShape.isRequired,
    children: element.isRequired,
};

export default BrandPage;
